import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "groups";

const initialState = {
  personal: DEFAULT_ENTITY_STATE,
  approver: DEFAULT_ENTITY_STATE,
  financial: DEFAULT_ENTITY_STATE,
  admin: DEFAULT_ENTITY_STATE,
  director: DEFAULT_ENTITY_STATE,
};

export const getGroups = createAsyncThunk(
  `${baseName}/getGroups`,
  async (role) => {
    const res = await HttpClient.get({
      url: "/groups",
      params: { role },
    });
    return res?.data;
  }
);

export const groupsSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupGroups(state, { payload }) {
      const { data, role } = payload || {};
      if (!state[role]) return;
      //CONFIGURAR ENTRADA DE DADOS
      state[role].data =
        data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    //ADM ACTIONS
    addGroup(state, { payload }) {
      state.admin.data.push(payload);
    },
    updateGroup(state, { payload }) {
      const { id, changes } = payload;
      const index = state.admin.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.admin.data[index] = {
          ...state.admin.data[index],
          ...changes,
        };
      }
    },
    removeGroup(state, { payload }) {
      state.admin.data = [
        ...state.admin.data?.filter((item) => item?.id !== payload),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroups.pending, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "loading";
        state[role].error = null;
      })
      .addCase(getGroups.rejected, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "failed";
        state[role].error = action.error.message || null;
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        const role = action.meta.arg || "expenses";
        state[role].status = "succeeded";
        state[role].error = null;

        //Dados API
        const data = action.payload || [];
        groupsSlice.caseReducers.setupGroups(state, {
          payload: {
            data,
            role,
          },
        });
      });
  },
});

export const { addGroup, removeGroup, setupGroups, updateGroup } =
  groupsSlice.actions;

export default groupsSlice.reducer;

export const selectGroupsByRole = createSelector(
  [(state) => state.groups, (state, role) => role],
  (groupsState = {}, role = "") => {
    const prevData = groupsState[role] || DEFAULT_ENTITY_STATE;

    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectGroupById = createSelector(
  [selectGroupsByRole, (state, role, groupId) => groupId],
  (groupsState = {}, groupId = "") => {
    return groupsState?.data?.find((item) => item?.id === groupId) || {};
  }
);
